import { useI18n } from '@platform/i18n';
import { CircleHelpIcon, InfoIcon } from 'lucide-react';
import { useState } from 'react';
import { Button } from '../components/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '../components/dropdown-menu';
import { useShortcut } from '../hooks/use-shortcut';
import { VersionDialog } from './version';

export interface ContextualHelpProps {
  href: string;
  label: string;
}

/**
 * The "?" menu of the app shell: opens the current page's audience documentation (also the F1 shortcut) or the
 * version dialog.
 */
export function ContextualHelp({ href, label }: ContextualHelpProps) {
  const { t } = useI18n();
  const [versionOpen, setVersionOpen] = useState(false);
  useShortcut('app.help', () => {
    window.open(href, '_blank', 'noopener,noreferrer');
  }, { enabled: Boolean(href), allowInInputs: true });

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon" aria-label={t('common.helpMenu')} title={t('common.helpMenu')}>
            <CircleHelpIcon aria-hidden="true" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem asChild>
            <a href={href} target="_blank" rel="noopener noreferrer">
              <CircleHelpIcon aria-hidden="true" />
              {label}
            </a>
          </DropdownMenuItem>
          <DropdownMenuItem onSelect={() => setVersionOpen(true)}>
            <InfoIcon aria-hidden="true" />
            {t('common.version.menu')}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <VersionDialog open={versionOpen} onOpenChange={setVersionOpen} />
    </>
  );
}
